import { useStoreApi } from '@xyflow/react';
import { useDebounceFn } from 'ahooks';
import { message } from 'antd';
import { tryit } from 'radash';
import { useCallback } from 'react';
import * as API from '../services';
import { useWorkflowStore } from '../store';
import { Edge, Node } from '../types';
import { useWorkflowReadOnly } from './use-workflow';
import { useWorkflowTemplate } from './use-workflow-template';
import { DATA_DIRTY } from '@/components/PdfRenderer/const';

export const useSyncDraft = () => {
  const store = useStoreApi<Node, Edge>();
  const workflowStore = useWorkflowStore();
  const { getNodesReadOnly } = useWorkflowReadOnly();
  const { nodes: templateNodes, edges: templateEdges } = useWorkflowTemplate();

  const getPostParams = useCallback(() => {
    const { nodes, edges } = store.getState();
    const { appId, template_code } = workflowStore.getState();
    if (!appId) return;

    //     const filteredNodes = nodes.map((node) => {
    //       const filteredData = Object.fromEntries(
    //         Object.entries(node.data).filter(([key]) => !key.startsWith('_')),
    //       );
    //       return { ...node, data: filteredData };
    //     });
    //
    //     const filteredEdges = edges.map((edge) => {
    //       if (!edge.data) return edge;
    //       const filteredData = Object.fromEntries(
    //         Object.entries(edge.data).filter(([key]) => !key.startsWith('_')),
    //       );
    //       return { ...edge, data: filteredData };
    //     });

    return {
      // nodes: filteredNodes,
      // edges: filteredEdges,
      nodes: nodes,
      edges: edges,
      template_code,
    };
  }, [store, workflowStore]);

  const doSyncWorkflowDraft = useCallback(
    async (
      options: {
        notRefreshWhenSyncError?: boolean;
      } = {},
    ) => {
      if (getNodesReadOnly()) return;

      const postParams = getPostParams();

      if (!postParams) return;

      const { notRefreshWhenSyncError } = options;

      workflowStore.setState({ isSyncingWorkflowDraft: true });
      const [error, res] = await tryit(API.syncWorkflowDraft)(postParams);

      if (error) {
        // message.error('同步失败');
        workflowStore.setState({ isSyncingWorkflowDraft: false });
        return;
      }

      workflowStore.setState({
        // syncWorkflowDraftHash: res.syncWorkflowDraftHash,
        draftUpdatedAt: Date.now(),
        isSyncingWorkflowDraft: false,
      });
    },

    [workflowStore, getNodesReadOnly],
  );

  const debouncedSyncWorkflowDraft = useDebounceFn(doSyncWorkflowDraft, {
    // TODO: DEV
    wait: 800,
    maxWait: 3000,
    leading: false,
    trailing: true,
  });

  const resetDraft = async () => {
    const { appId, syncWorkflowDraftHash, template_code } =
      workflowStore.getState();
    await tryit(API.syncWorkflowDraft)({
      template_code,
      nodes: templateNodes,
      edges: templateEdges,
    });
  };

  return {
    doSyncWorkflowDraft,
    debouncedSyncWorkflowDraft,
    resetDraft,
  };
};
